import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock } from "lucide-react";
import api from "@/lib/api";
import { useCart } from "@/contexts/CartContext";

export default function CheckoutSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { clear } = useCart();
  const [state, setState] = useState({ status: "checking", message: "Checking your payment..." });
  const polledRef = useRef(false);

  useEffect(() => {
    if (!sessionId) { setState({ status: "error", message: "Missing session id" }); return; }
    if (polledRef.current) return;
    polledRef.current = true;

    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      if (attempts > 10) {
        setState({ status: "pending", message: "Payment is still processing. We'll email you shortly." });
        return;
      }
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setState({ status: "paid", message: "Payment received — your little friend is on the way!" });
          clear();
          return;
        }
        if (data.status === "expired") {
          setState({ status: "expired", message: "Your session expired. Please try again." });
          return;
        }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2500);
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="container-x py-24" data-testid="checkout-success">
      <div className="max-w-xl mx-auto text-center card-soft p-12">
        {state.status === "paid" ? (
          <CheckCircle2 size={56} className="text-[#A3B18A] mx-auto" />
        ) : (
          <Clock size={56} className="text-[#D97757] mx-auto" />
        )}
        <h1 className="font-serif text-4xl mt-6">
          {state.status === "paid" ? "Thank you" : "Just a moment"}
        </h1>
        <p className="mt-3 text-[#5C4D43]">{state.message}</p>
        <Link to="/shop" className="btn-primary inline-block mt-8" data-testid="success-continue">
          Continue browsing
        </Link>
      </div>
    </div>
  );
}
